
import { FileProtectOutlined, ArrowLeftOutlined, StopOutlined, IssuesCloseOutlined, BarsOutlined, EnvironmentOutlined, InfoCircleFilled } from '@ant-design/icons';
import { Alert, Button, Checkbox, Col, Descriptions, Form, FormInstance, Input, Radio, Space, Tooltip } from 'antd';
import { Brand } from '../../baseInfo/brand';
import { City } from '../../baseInfo/city';
import { ICity, ICityProps } from '../../baseInfo/city/interfaces';
import { DamageReason } from '../../baseInfo/damageReason';
import { IDamageReason } from '../../baseInfo/damageReason/interfaces';
import { EquipmentItem } from '../../baseInfo/equipment/equipmentItem';
import { Province } from '../../baseInfo/province';
import { IProvince } from '../../baseInfo/province/interfaces';
import { enmControlType, IProperty } from '../../components/entityManager/interfaces';
import { BaseComponent, IBaseProps, IBaseStates } from "../../components/infrastructure/baseComponent";
import { ICallOptions, IResultSet } from '../../components/infrastructure/models';
import { Lookup } from '../../components/lookup';
import { DatePicker as DatePickerJalali } from "antd-jalali";
import TextArea from 'antd/lib/input/TextArea';
import { ICenter } from '../../baseInfo/center/interfaces';
import { IPolicyEquipmentModel } from '../../baseInfo/policyEquipmentModel/interfaces';
import { enmEvaluationMethods, evaluationMethodsOptions, IDamageCase } from '../../baseInfo/damageCase/interfaces';
import AppContext, { AppContextProps } from '../../components/infrastructure/appContext';
import { UploadDocuments } from './uploadDocuments';
import { Redirect } from 'react-router-dom';
import { DamageCasePolicyholder } from '.';
import { Evaluator, IEvaluatorFetchingResultDto, IEvaluatorProps } from './evaluator';
import { InquiryPolicy } from '../policy/inquiry';
import { EquipmentModel } from '../../baseInfo/equipmentModel';
import { IPolicyListProps, PolicyList } from '../policy';
import SimpleMap from '../../components/map';
import { Core } from '../../components/infrastructure/core';

interface IDamageCaseCreateProps extends IBaseProps {
    close?: () => void;
    defaultPolicyEquipmentModel?: IPolicyEquipmentModel;
}

interface IEvaluatorDto {
    FullName?: string;
    Code: number;
    Phone?: string;
    ProvinceName?: string;
    CityName?: string;
    Address?: string;
    WorkTime?: string;
    Latitude?: number | null;
    Longitude?: number | null;
}

interface IDamageCaseCreateStates extends IBaseStates {
    damageReason?: IDamageReason;
    emergencyCallNumber: string;
    sendingItems: ISendingItem[];
    selectedEvaluator?: IEvaluatorDto;
    damageProvince?: IProvince;
    damageCity?: ICity;
    damageAddress?: string;
    province?: IProvince;
    city?: ICity;
    address?: string;
    damageDate?: any;
    description?: string;
    confirmPossessionTransition?: boolean;
    policyEquipmentModel?: IPolicyEquipmentModel;
    evaluationMethod?: enmEvaluationMethods;
    saved?: boolean;
    evaluatorsCount: number;
}

interface ISendingItem {
    Id: number;
    Name: string;
    IsAvailable: boolean;
    Code: string;
}

const SendingItemList = (props: { items: ISendingItem[], onChange: (items: ISendingItem[]) => void; }) => {
    const list = props.items.map(item =>
        <Descriptions.Item key={item.Id} >
            <Checkbox defaultChecked={item.IsAvailable} onChange={(e) => {
                props.items.find(i => i.Id === item.Id)!.IsAvailable = e.target.checked;
                props.onChange(props.items);
            }}>
                {item.Name}
            </Checkbox>
        </Descriptions.Item>);
    return (
        <Descriptions key="SendingItemList" layout='horizontal' column={{ xxl: 8, xl: 6, lg: 4, md: 3, sm: 2, xs: 1 }}>
            {list}
        </Descriptions>
    );
}

export class DamageCaseCreate extends BaseComponent<IDamageCaseCreateProps, IDamageCaseCreateStates>{
    static contextType = AppContext;
    _form?: FormInstance;

    policyEquipmentModelProp: IProperty;
    equipmentProp: IProperty;
    brandProp: IProperty;
    equipmentModelProp: IProperty;
    damageReasonProp: IProperty;
    damageProvinceProp: IProperty;
    damageCityProp: IProperty;
    provinceProp: IProperty;
    cityProp: IProperty;
    evaluatorProp: IProperty;
    container?: HTMLDivElement | null;
    constructor(props: IDamageCaseCreateProps) {
        super(props)
        this.state = {
            isAuthorized: true,
            loading: true,
            windowSize: window.innerWidth <= 765 ? 1 : 2,
            emergencyCallNumber: '',
            sendingItems: [],
            evaluatorsCount: 0
        };

        this.title = "ثبت خسارت بیمه نامه";

        this.policyEquipmentModelProp = {
            controlType: enmControlType.lookup,
            dataIndex: "PolicyEquipmentModelId",
            width: "100%",
            lookup: {
                lookupComponent: PolicyList,
                lookupProperty: "Policy.Code",
                lookupDisplayFields: ["Policy.SerialNo"],
                dropdownDisplayFields: ["Policy.SerialNo", "EquipmentSerialNo", "BrandTitle", "EquipmentModelTitle", "Policy.StartDateTime", "Policy.EndDateTime"],
                showButton: false,

            }
        };
        this.equipmentProp = {
            controlType: enmControlType.lookup,
            dataIndex: "EquipmentId",
            width: "100%",
            lookup: {
                lookupComponent: EquipmentItem,
                lookupProperty: "Code",
                lookupDisplayFields: ["Name"],
                showButton: false
            }
        };
        this.brandProp = {
            controlType: enmControlType.lookup,
            dataIndex: "BrandId",
            width: "100%",
            lookup: {
                lookupComponent: Brand,
                lookupProperty: "Code",
                lookupDisplayFields: ["Name"],
                showButton: false
            }
        };
        this.equipmentModelProp = {
            controlType: enmControlType.lookup,
            dataIndex: "EquipmentModelId",
            width: "100%",
            lookup: {
                lookupComponent: EquipmentModel,
                lookupProperty: "Code",
                lookupDisplayFields: ["Name"],
                showButton: false

            }
        };
        this.damageReasonProp = {
            controlType: enmControlType.lookup,
            dataIndex: "DamageReasonId",
            width: "100%",
            lookup: {
                lookupComponent: DamageReason,
                lookupProperty: "Id",
                lookupDisplayFields: ["Name"],
                dropdownDisplayFields: ["Name"],
                showButton: false
            }
        };
        this.damageProvinceProp = {
            controlType: enmControlType.lookup,
            dataIndex: "DamageProvinceId",
            width: "100%",
            lookup: {
                lookupComponent: Province,
                lookupProperty: "Id",
                lookupDisplayFields: ["Name"],
                showButton: false,
                dropdownDisplayFields: ["Name"]
            }
        };
        this.damageCityProp = {
            controlType: enmControlType.lookup,
            dataIndex: "DamageCityId",
            width: "100%",
            lookup: {
                lookupComponent: City,
                lookupProperty: "Id",
                lookupDisplayFields: ["Name"],
                showButton: false,
                dropdownDisplayFields: ["Name"]
            }
        };
        this.provinceProp = {
            controlType: enmControlType.lookup,
            dataIndex: "ProvinceId",
            width: "100%",
            lookup: {
                lookupComponent: Province,
                lookupProperty: "Id",
                lookupDisplayFields: ["Name"],
                showButton: false,
                dropdownDisplayFields: ["Name"]
            }
        };
        this.cityProp = {
            controlType: enmControlType.lookup,
            dataIndex: "CityId",
            width: "100%",
            lookup: {
                lookupComponent: City,
                lookupProperty: "Id",
                lookupDisplayFields: ["Name"],
                showButton: false,
                dropdownDisplayFields: ["Name"]
            }
        };
        this.evaluatorProp = {
            controlType: enmControlType.lookup,
            dataIndex: "EvaluatorId",
            width: "100%",
            lookup: {
                lookupComponent: Evaluator,
                lookupProperty: "Id",
                lookupDisplayFields: ["Name"],
                showButton: false,
                dropdownDisplayFields: ["Name", "ProvinceName", "CityName", "Phone", "Address", "WorkTime"]
            }
        };
    }
    componentDidMount() {
        super.componentDidMount();
        this.initializing();
    }
    initializing = () => {
        let fetchingInfo = {
            Orderings: [],
        };
        let fetchOpt: ICallOptions = {
            url: "sendingitem/get",
            data: {
                fetchingInfo
            },
            onSuccess: (result: IResultSet<any>) => {
                const { getUserInfo } = this.context as AppContextProps;
                const userInfo = getUserInfo();

                if (result.ValidationState.Successful) {
                    const policyEquipmentModel = this.props.defaultPolicyEquipmentModel;
                    this._form?.setFields([
                        { name: 'emergencyCallNumber', value: userInfo?.phone ? '0' + userInfo.phone : '' },
                        { name: 'policyEquipmentModel', value: policyEquipmentModel }
                    ]);
                    this.setState({ sendingItems: result.Data ?? [], emergencyCallNumber: userInfo?.phone ? '0' + userInfo.phone : '', policyEquipmentModel });
                }
            },
            onError: () => {

            }
        };
        this.callApi(fetchOpt);
    }
    onChangeDamageDate = (e: any) => {
        if (e) {
            let parsedDate = e.toDate();
            parsedDate = new Date(parsedDate.toDateString());
            this.setState({ damageDate: parsedDate.toDateString() });
        }
        else
            this.setState({ damageDate: undefined });

    }
    submitDamage = async () => {
        let opt: ICallOptions = {
            withBlock: true,
            withBlockTitle:'در حال ثبت خسارت...',
            url: "portal/createcase",
            data: {
                damageCase: {
                    IssuerType: 1, // Self
                    InsurerId: 1,
                    TicketNo: 0,
                    EmergencyCallNumber: this.state.emergencyCallNumber,
                    DamageDate: this.state.damageDate,
                    DamageProvinceCode: this.state.damageProvince?.Code,
                    DamageCityCode: this.state.damageCity?.Code,
                    DamageAddress: this.state.damageAddress,
                    ProvinceCode: this.state.province?.Code,
                    CityCode: this.state.city?.Code,
                    Address: this.state.address,
                    DamageReasonCode: this.state.damageReason?.Code,
                    Description: this.state.description,
                    ConfirmPossessionTransition: this.state.confirmPossessionTransition,
                    EvaluationMethod: this.state.damageReason?.Name?.includes('سرقت') === true ? enmEvaluationMethods.PolicyholderInPerson : this.state.evaluationMethod,
                    Policy: {
                        SerialNo: this.state.policyEquipmentModel?.Policy?.SerialNo === 'فاقد سریال' ? undefined : this.state.policyEquipmentModel?.Policy?.SerialNo,
                        EquipmentSerialNo: this.state.policyEquipmentModel?.EquipmentSerialNo
                    },
                    Policyholder: {
                        NationalCode: this.state.policyEquipmentModel?.Policy?.Policyholder?.NationalCode
                    },
                    AvailableItems: this.state.sendingItems.filter(s => s.IsAvailable).map(s => s.Code),
                    EvaluatorCode: this.state.policyEquipmentModel?.Policy?.CheckPolicyDate && this.state.damageReason?.Name?.includes('سرقت') !== true ? this.state.selectedEvaluator?.Code : 1
                }
            },
            onSuccess: (result: IResultSet<any>) => {
                const createdItem = result.Data as { ticketNo: number; essentialDocuments: { Name: string; Code: string; }[]; };
                if (result.ValidationState.Successful && !!createdItem) {
                    setTimeout(() => {
                        this.damageCreated(createdItem.ticketNo, createdItem.essentialDocuments);
                    }, 100);
                }
            }
        };
        await this.callApi(opt);
    }
    damageCreated = (ticketNo?: number, essentialDocuments?: { Name: string; Code: string; }[]) => {
        if (!ticketNo || !essentialDocuments) {
            return;
        }
        this.uploadDocuments(ticketNo, essentialDocuments);
    }
    uploadDocuments = (ticketNo: number, essentialDocuments?: { Name: string; Code: string; }[]) => {
        this.addLookupForm("UploadDocuments",
            <UploadDocuments
                key="UploadDocuments"
                invokePath={"ثبت خسارت"}
                isChildComponent={true}
                ticketNo={ticketNo}
                essentialDocuments={essentialDocuments}
                removeable={true}
                onRemove={this.removeDamageCase}
                onClose={() => {
                    if (this.props.close)
                        this.props.close();
                    else
                        this.setState({ saved: true });
                }}
            />);
    }
    removeDamageCase = async (ticketNo: number) => {
        let fetchOpt: ICallOptions = {
            url: "portal/RemoveDamageCase",
            data: { ticketNo },
            onSuccess: result => {
                if (result.ValidationState.Successful) {
                    Core.successNotification('پرونده خسارت شما حذف شد');
                }
            },
            onError: () => {

            }
        };
        await this.callApi(fetchOpt);
    }
    showCurrentPolicyDamageCase = (damageCase: IDamageCase) => {
        this.addLookupForm("CurrentPolicyDamageCase",
            <DamageCasePolicyholder
                invokePath="ثبت خسارت"
                defaultDamageCaseId={damageCase.Id}
                onClose={() => this.setState({ displayLookupForm: undefined })}
            />
        );
    }
    policyEquipmentModelValidator = () => {
        const { policyEquipmentModel } = this.state;
        if (policyEquipmentModel) {
            const policy = policyEquipmentModel.Policy;
            let endDateTime = new Date(policy.EndDateTime);
            let startDateTime = new Date(policy.StartDateTime);
            if (policy.CheckPolicyDate) {
                let currentDate = new Date();
                endDateTime.setMonth(endDateTime.getMonth());
                startDateTime.setMonth(startDateTime.getMonth());
                if (currentDate.getTime() > endDateTime.getTime() || currentDate.getTime() < startDateTime.getTime()) {
                    return Promise.reject(new Error('امکان ثبت خسارت در زمانی غیر از بازه تاریخ اعتبار بیمه نامه وجود ندارد.'));
                }
                if (!!this.state.damageDate) {
                    let damageDate = new Date(this.state.damageDate);
                    if (damageDate.getTime() > endDateTime.getTime() || damageDate.getTime() < startDateTime.getTime()) {
                        return Promise.reject(new Error('امکان ثبت خسارت با تاریخ وقوع خسارت غیر از بازه تاریخ اعتبار بیمه نامه وجود ندارد.'));
                    }
                }
            }

            const damageCase = policyEquipmentModel.DamageCases[0];
            if (!!damageCase) {
                if (!!damageCase.PayableAmount) {
                    const payableAmount = `${damageCase.PayableAmount}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                    return Promise.reject(new Error(`شما در خصوص بیمه نامه انتخاب شده مبلغ ${payableAmount} خسارت دریافت کرده اید و امکان ثبت خسارت وجود نخواهد داشت.`));
                }
                else {
                    return Promise.reject(
                        <>
                            <span>در خصوص بیمه نامه انتخاب شده، دارای</span>
                            <Tooltip title="مشاهده پرونده">
                                <Button type="link" style={{ margin: 0, width: 80, padding: 0 }} onClick={() => this.showCurrentPolicyDamageCase(damageCase)}><b>پرونده</b></Button>
                            </Tooltip>
                            <span>می‌باشید</span>
                        </>
                    );
                }
            }
        }
        return Promise.resolve();
    }
    damageDateValidator = () => {
        const damageDate = this.state.damageDate;
        const currentDate = new Date(new Date().toDateString());
        if (new Date(damageDate).getTime() > currentDate.getTime())
            return Promise.reject(new Error('تاریخ آینده برای وقوع حادثه قابل قبول نیست'));
        return Promise.resolve();
    }
    inquiryPolicy = () => {
        this.addLookupForm("InquiryPolicy",
            <InquiryPolicy key="InquiryPolicy"
                onClose={data => {
                    this._form?.setFields([
                        { name: 'policyEquipmentModel', value: data }
                    ]);
                    this.setState({ policyEquipmentModel: data })
                    this.onLookupClosed();
                }}
            />);
    }
    virtualRender() {

        const header = this.getPageHeader({
            title: this.title,
            onBack: () => {
                if (this.props.close)
                    this.props.close();
                else
                    window.history.back();
            }
        });

        if (this.state.saved)
            return <Redirect to={"/damagecasepolicyholder"} />

        const span = window.matchMedia("(min-width: 992px)").matches ? 2 : 1;

        let messageNode: JSX.Element | undefined = undefined;
        if (this.state.evaluationMethod === enmEvaluationMethods.PolicyholderInPerson)
            messageNode = (
                <div style={{ lineHeight: 2.2 }}>
                    <div>
                        بیمه گزار/مشتری گرامی، درصورت نیاز، زمان، تاریخ و نحوه ارزیابی مراجعه حضوری به ارزیاب از طریق پیام کوتاه و ایمیل حضورتان اطلاع رسانی خواهد شد. لطفاً در هنگام مراجعه به ارزیاب، مدارک زیر جهت سهولت در روند ارزیابی را به همراه داشته باشید :
                    </div>
                    <ul style={{ listStyleType: 'none' }}>
                        <li>1. مدارک شناسایی (کارت ملّی یا شناسنامه)</li>
                        <li>2. در حالاتی غیر از حالات سرقت کلی، سرقت با شکست حرز و سیل و طوفان ارائه دستگاه آسیب دیده به همراه جعبه دستگاه و متعلقات الزامی است.</li>
                        <li>3. اصل سایر مدارک آپلود شده</li>
                    </ul>
                </div>
            );
        //else if (this.state.evaluationMethod === enmEvaluationMethods.EvaluatorInPerson)
        //    messageNode = (
        //        <div style={{ lineHeight: 2.2 }}>
        //            <div>
        //                بیمه گزار/مشتری گرامی، درصورت نیاز، زمان، تاریخ و نحوه ارزیابی مراجعه حضوری ارزیاب از طریق پیام کوتاه و ایمیل حضورتان اطلاع رسانی خواهد شد. لطفاً در هنگام مراجعه ارزیاب، مدارک زیر جهت سهولت در روند ارزیابی آماده گردد:
        //            </div>
        //            <ul style={{ listStyleType: 'none' }}>
        //                <li>1. مدارک شناسایی (کارت ملّی یا شناسنامه)</li>
        //                <li>2. در حالاتی غیر از حالات سرقت کلی، سرقت با شکست حرز و سیل و طوفان ارائه دستگاه آسیب دیده الزامی است.</li>
        //                <li>3. اصل سایر مدارک آپلود شده</li>
        //            </ul>
        //        </div>
        //    );
        else if (this.state.evaluationMethod === enmEvaluationMethods.VideoCall)
            messageNode = (
                <div style={{ lineHeight: 2.2 }}>
                    بیمه گزار/مشتری گرامی، درصورت نیاز، زمان، تاریخ و نحوه ارزیابی تماس تصویری از طریق پیام کوتاه، حضورتان اطلاع رسانی خواهد شد
                </div>
            );

        evaluationMethodsOptions.forEach(e => {
            e.disabled =
                (!this.state.evaluatorsCount && e.value !== enmEvaluationMethods.VideoCall && !this.state.damageReason?.Name.includes('سرقت'))
                ||
                (!!this.state.evaluatorsCount && e.value !== enmEvaluationMethods.PolicyholderInPerson)
                ;
        });

        const disableEvaluator = this.state.policyEquipmentModel?.Policy && !this.state.policyEquipmentModel.Policy.CheckPolicyDate; //(this.state.damageReason && this.state.damageReason.Name.includes('سرقت')) || (this.state.policyEquipmentModel?.Policy && !this.state.policyEquipmentModel.Policy.CheckPolicyDate);

        return (
            <div ref={node => this.container = node}>
                {header}
                <Form

                    labelCol={{ span: 8 }}
                    wrapperCol={{ span: 14 }}
                    layout={'horizontal'}
                    ref={node => { if (node) this._form = node }}
                    onFinish={async () => {
                        await this.submitDamage();
                    }}
                    onReset={() => {
                        if (this.props.close)
                            this.props.close();
                        else
                            window.history.back();
                    }}
                    onFinishFailed={errorInfo => {
                        if (this.container && errorInfo.errorFields.length) {
                            const { name } = errorInfo.errorFields[0];
                            const label = this.container.querySelector(`[for="${name[0]}"]`);
                            label?.scrollIntoView();
                            const field = this._form?.getFieldInstance(name[0]);
                            if (field?.focus)
                                field.focus();
                        }
                    }}
                >
                    <div key="policyinfo" className="box box-blue">
                        <div className="box-title">
                            <div className="caption">
                                <FileProtectOutlined style={{ margin: 2, verticalAlign: 'text-top' }} />
                                انتخاب بیمه نامه
                            </div>
                        </div>
                        <div className="box-body form">
                            <div className="form-body">

                                <Alert
                                    style={{ marginTop: 10, marginBottom: 20, textAlign: 'justify' }}
                                    message={
                                        <>
                                            بیمه گزار/مشتری گرامی، چنانچه بیمه نامه مد نظر در لیست زیر موجود نیست، از طریق
                                            <Button key="inquiryPolicyButton" type="link" style={{ padding: 4 }} onClick={() => this.inquiryPolicy()}><b>استعلام بیمه نامه</b></Button>
                                            نسبت به ثبت دستگاه خود اقدام نمایید.
                                        </>
                                    }
                                    type="info"
                                    icon={<InfoCircleFilled className="blink" />}
                                    showIcon
                                />
                                <Descriptions layout='horizontal' column={{ xl: 2, lg: 2, md: 1, sm: 1, xs: 1 }} >
                                    <Descriptions.Item key="policyEquipmentModel">
                                        <Form.Item
                                            name="policyEquipmentModel"
                                            key="policyEquipmentModel"
                                            label="بیمه نامه"
                                            style={{ width: "100%" }}
                                            rules={[
                                                { required: true, message: 'بیمه نامه اجباری است' },
                                                { validator: this.policyEquipmentModelValidator }
                                            ]}
                                        >
                                            <Lookup
                                                parent={this}
                                                key="PolicyEquipmentModelId"
                                                onChange={(policyEquipmentModel?: IPolicyEquipmentModel) => {
                                                    this._form?.resetFields(["selectedEvaluator"]);
                                                    this.setState({ policyEquipmentModel, selectedEvaluator: undefined });
                                                }}
                                                onDataFetched={result => {
                                                    result && result.Data && result.Data.forEach(item => {
                                                        if (!item["Policy"]["SerialNo"] || item["Policy"]["SerialNo"] === "")
                                                            item["Policy"]["SerialNo"] = 'فاقد سریال';
                                                    });
                                                }}
                                                property={this.policyEquipmentModelProp}
                                                preparelookupProps={(props: IPolicyListProps) => {
                                                    props.params = () => {
                                                        return {
                                                            loadPolicyDamageCases: true
                                                        };
                                                    };
                                                    return props;
                                                }}
                                            />
                                        </Form.Item>
                                    </Descriptions.Item>
                                    <Descriptions.Item key="EquipmentId">
                                        <Form.Item
                                            key="EquipmentId"
                                            label="دستگاه/تجهیز"
                                            style={{ width: "100%" }}
                                        >
                                            <Lookup
                                                key="EquipmentId"
                                                parent={this}
                                                disabled
                                                property={this.equipmentProp}
                                                value={this.state.policyEquipmentModel?.Equipment}
                                            />
                                        </Form.Item>
                                    </Descriptions.Item>
                                    <Descriptions.Item key="BrandId">
                                        <Form.Item
                                            key="BrandId"
                                            label="برند"
                                            style={{ width: "100%" }}
                                        >
                                            <Lookup
                                                parent={this}
                                                disabled
                                                key="BrandId"
                                                property={this.brandProp}
                                                defaultText={this.state.policyEquipmentModel?.BrandTitle}
                                                value={this.state.policyEquipmentModel?.Brand}
                                            />
                                        </Form.Item>
                                    </Descriptions.Item>
                                    <Descriptions.Item key="EquipmentModelId">
                                        <Form.Item
                                            key="EquipmentModelId"
                                            label="مدل"
                                            style={{ width: "100%" }}
                                            rules={[{ required: true, message: 'مدل اجباری است' }]}
                                        >
                                            <Lookup
                                                parent={this}
                                                disabled
                                                key="EquipmentModelId"
                                                property={this.equipmentModelProp}
                                                value={this.state.policyEquipmentModel?.EquipmentModel}
                                                defaultText={this.state.policyEquipmentModel?.EquipmentModelTitle}
                                            />
                                        </Form.Item>
                                    </Descriptions.Item>
                                    <Descriptions.Item key="EquipmentSerialNo">
                                        <Form.Item
                                            label="سریال دستگاه (IMEI)"
                                            style={{ width: "100%" }}
                                            key="EquipmentSerialNo"
                                        >
                                            <Input
                                                disabled
                                                key="EquipmentSerialNo"
                                                value={this.state.policyEquipmentModel?.EquipmentSerialNo}
                                            />
                                        </Form.Item>
                                    </Descriptions.Item>
                                    <Descriptions.Item key="emergencyCallNumber">
                                        <Form.Item
                                            name="emergencyCallNumber"
                                            key="emergencyCallNumber"
                                            label="شماره موبایل در دسترس"
                                            style={{ width: "100%" }}
                                            rules={[
                                                { required: true, message: 'شماره موبایل اجباری است' },
                                                { len: 11, message: 'شماره موبایل باید 11 رقم باشد' },
                                                {
                                                    validator: () => {
                                                        if (!this.state.emergencyCallNumber?.startsWith('0'))
                                                            return Promise.reject(new Error('شماره موبایل با 0 آغاز شود'));
                                                        return Promise.resolve();
                                                    }
                                                }
                                            ]}
                                            initialValue={this.state.emergencyCallNumber}
                                        >
                                            <Input
                                                style={{ width: "100%" }}
                                                type={"text"}
                                                onKeyPress={(event) => {
                                                    if (event.charCode < 48 || event.charCode > 57) {
                                                        event.preventDefault();
                                                    }
                                                }}
                                                onChange={e => {
                                                    this.setState({ emergencyCallNumber: e.target.value });
                                                }}
                                                value={this.state.emergencyCallNumber}
                                                maxLength={11}
                                            />
                                        </Form.Item>
                                    </Descriptions.Item>
                                </Descriptions>
                            </div>
                        </div>
                    </div>

                    <div key="damageinfo" className="box box-blue" style={{ marginTop: 10 }}>
                        <div className="box-title">
                            <div className="caption">
                                <IssuesCloseOutlined style={{ margin: 2, verticalAlign: 'text-top' }} />
                                اطلاعات خسارت
                            </div>
                        </div>
                        <div className="box-body form">
                            <div className="form-body">
                                <Descriptions layout='horizontal' column={{ xl: 2, lg: 2, md: 1, sm: 1, xs: 1 }}>
                                    <Descriptions.Item key="damageDate">
                                        <Form.Item
                                            name="damageDate"
                                            key="damageDate"
                                            label="تاریخ وقوع"
                                            style={{ width: "100%" }}
                                            rules={[
                                                { required: true, message: 'تاریخ وقوع خسارت اجباری است' },
                                                { validator: this.damageDateValidator }
                                            ]}
                                        >
                                            <DatePickerJalali
                                                onChange={this.onChangeDamageDate}
                                                format="YYYY/MM/DD"
                                                inputReadOnly={true}
                                                style={{ width: '100%', display: 'block' }}
                                            />
                                        </Form.Item>
                                    </Descriptions.Item>
                                    <Descriptions.Item key="damageReason">
                                        <Form.Item
                                            name="damageReason"
                                            key="damageReason"
                                            label="خسارت بر اثر"
                                            style={{ width: "100%" }}
                                            rules={[
                                                { required: true, message: 'دلیل خسارت اجباری است' }
                                            ]}
                                        >
                                            <Lookup
                                                key="damageReason"
                                                parent={this}
                                                onChange={(damageReason?: IDamageReason) => {
                                                    this._form?.resetFields(["EvaluationMethod", "selectedEvaluator"]);
                                                    this.setState({ damageReason, evaluationMethod: undefined, selectedEvaluator: undefined });
                                                }}
                                                property={this.damageReasonProp}
                                            />
                                        </Form.Item>
                                    </Descriptions.Item>
                                    <Descriptions.Item key="damageProvince">
                                        <Form.Item
                                            name="damageProvince"
                                            key="damageProvince"
                                            label="استان وقوع حادثه"
                                            style={{ width: "100%" }}
                                        >
                                            <Lookup
                                                key="damageProvince"
                                                parent={this}
                                                onChange={(province?: IProvince) => {
                                                    this.setState({ damageProvince: province, damageCity: undefined });
                                                    this._form?.resetFields(["damageCity"]);
                                                    this._form?.setFields([{ name: "damageCity", value: null }]);
                                                }}
                                                property={this.damageProvinceProp}
                                            />
                                        </Form.Item>
                                    </Descriptions.Item>
                                    <Descriptions.Item key="damageCity">
                                        <Form.Item
                                            name="damageCity"
                                            key="damageCity"
                                            label="شهر وقوع حادثه"
                                            style={{ width: "100%" }}
                                        >
                                            <Lookup
                                                key="damageCity"
                                                parent={this}
                                                onChange={(city?: ICity) => {
                                                    const province = city?.Province;
                                                    if (!this.state.damageProvince) {
                                                        this._form?.resetFields(["damageProvince"]);
                                                        this._form?.setFields([{ name: "damageProvince", value: province }]);
                                                        this.setState({ damageCity: city, damageProvince: province });
                                                    }
                                                    else
                                                        this.setState({ damageCity: city });
                                                }}
                                                property={this.damageCityProp}
                                                preparelookupProps={(lookupProps: ICityProps) => {
                                                    lookupProps.params = () => {
                                                        let province = this.state.damageProvince;
                                                        return { province };
                                                    };
                                                    return lookupProps;
                                                }}
                                            />
                                        </Form.Item>
                                    </Descriptions.Item>
                                    <Descriptions.Item key="damageAddress">
                                        <Form.Item
                                            key="damageAddress"
                                            name="damageAddress"
                                            label="آدرس وقوع حادثه"
                                            style={{ width: "100%" }}
                                        >
                                            <TextArea
                                                value={this.state.damageAddress}
                                                onChange={e => this.setState({ damageAddress: e.target.value })}
                                            />
                                        </Form.Item>
                                    </Descriptions.Item>
                                    <Descriptions.Item key="description">
                                        <Form.Item
                                            key="description"
                                            name="description"
                                            label="توضیحات"
                                            style={{ width: "100%" }}
                                            rules={[{ required: true, message: 'توضیحات اجباری است' }]}
                                        >
                                            <TextArea
                                                value={this.state.description}
                                                onChange={e => this.setState({ description: e.target.value })}
                                            />
                                        </Form.Item>
                                    </Descriptions.Item>
                                    <Descriptions.Item key="confirmPossessionTransition" span={1}>
                                        <Form.Item
                                            key="confirmPossessionTransition"
                                            name="confirmPossessionTransition"
                                            label="تایید انتقال مالکیت"
                                            style={{ width: "100%" }}
                                            valuePropName="checked"
                                        >
                                            <Checkbox onChange={e => this.setState({ confirmPossessionTransition: e.target.checked })}>
                                                در صورت وقوع خسارت سرقت و یا خسارت کلی، مالکیت دستگاه شما با انتقال رجیستری به مالکیت بیمه سامان در خواهد آمد و در صورت پیدا شدن دستگاه، مالکیت دستگاه متعلق به بیمه سامان خواهد بود.
                                            </Checkbox>
                                        </Form.Item>
                                    </Descriptions.Item>
                                </Descriptions >
                            </div>
                        </div>
                    </div>

                    <div key="existparts" className="box box-blue" style={{ marginTop: 10 }}>
                        <div className="box-title">
                            <div className="caption">
                                <BarsOutlined style={{ margin: 2, verticalAlign: 'text-top' }} rotate={180} />
                                اقلام موجود
                            </div>
                        </div>
                        <div className="box-body form">
                            <div className="form-body">
                                <Form.Item wrapperCol={{ span: 24 }} key="sendingItems">
                                    <SendingItemList items={this.state.sendingItems} onChange={items => this.setState({ sendingItems: items })} />
                                </Form.Item>
                            </div>
                        </div>
                    </div>

                    <div key="location" className="box box-blue" style={{ marginTop: 10 }}>
                        <div className="box-title">
                            <div className="caption">
                                <EnvironmentOutlined style={{ margin: 2, verticalAlign: 'text-top' }} />
                                اطلاعات محل حضور دستگاه
                            </div>
                        </div>
                        <div className="box-body form">
                            <div className="form-body">
                                <Descriptions layout='horizontal' column={{ xl: 2, lg: 2, md: 1, sm: 1, xs: 1 }}>
                                    <Descriptions.Item key="province">
                                        <Form.Item
                                            name="province"
                                            key="province"
                                            label="استان محل حضور دستگاه"
                                            style={{ width: "100%" }}
                                            rules={[
                                                { required: true, message: 'استان محل حضور دستگاه اجباری است' }
                                            ]}
                                        >
                                            <Lookup
                                                parent={this}
                                                onChange={(province?: IProvince) => {
                                                    this.setState({ province: province, city: undefined });
                                                    this._form?.resetFields(["city", "selectedEvaluator"]);
                                                    //this._form?.setFields([{ name: "city", value: null }]);
                                                }}
                                                property={this.provinceProp}
                                            />
                                        </Form.Item>
                                    </Descriptions.Item>
                                    <Descriptions.Item key="city">
                                        <Form.Item
                                            name="city"
                                            key="city"
                                            label="شهر محل حضور دستگاه"
                                            style={{ width: "100%" }}
                                            rules={[
                                                { required: true, message: 'شهر محل حضور دستگاه اجباری است' }
                                            ]}
                                        >
                                            <Lookup
                                                parent={this}
                                                onChange={(city?: ICity) => {
                                                    const province = city?.Province;
                                                    this._form?.resetFields(["selectedEvaluator"]);
                                                    if (!this.state.province) {
                                                        this._form?.resetFields(["province"]);
                                                        this._form?.setFields([{ name: "province", value: province }]);
                                                        this.setState({ city, province, selectedEvaluator: undefined });
                                                    }
                                                    else
                                                        this.setState({ city, selectedEvaluator: undefined });
                                                }}
                                                property={this.cityProp}
                                                preparelookupProps={(lookupProps: ICityProps) => {
                                                    lookupProps.params = () => {
                                                        let province = this.state.province;
                                                        return { province };
                                                    };
                                                    return lookupProps;
                                                }}
                                            />
                                        </Form.Item>
                                    </Descriptions.Item>
                                    <Descriptions.Item key="address" span={1}>
                                        <Form.Item
                                            key="address"
                                            name="address"
                                            label="آدرس محل حضور دستگاه"
                                            style={{ width: "100%" }}
                                            rules={[{ required: true, message: 'آدرس محل حضور دستگاه اجباری است' }]}
                                        >
                                            <TextArea
                                                value={this.state.address}
                                                onChange={e => this.setState({ address: e.target.value })}
                                            />
                                        </Form.Item>
                                    </Descriptions.Item>
                                </Descriptions >
                            </div>
                        </div>
                    </div>

                    {!!this.state.damageReason && this.state.damageReason?.Name?.includes('سرقت') !== true &&
                        <div key="evaluation" className="box box-blue" style={{ marginTop: 10 }}>
                            <div className="box-title">
                                <div className="caption">
                                    <BarsOutlined style={{ margin: 2, verticalAlign: 'text-top' }} rotate={180} />
                                    روش ارزیابی
                                </div>
                            </div>
                            <div className="box-body form">
                                <div className="form-body">
                                    <Descriptions>
                                        <Descriptions.Item key={'EvaluationMethod'} className="ant-col-24">
                                            <Form.Item
                                                label={'لطفاً روش دلخواه ارزیابی دستگاه آسیب دیده خود را در صورت نیاز، انتخاب فرمایید'}
                                                name={'EvaluationMethod'}
                                                key={'EvaluationMethod'}
                                                labelCol={{ style: { lineHeight: 'normal', width: '100%' } }}
                                                wrapperCol={{ span: 16 }}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: 'پاسخ اجباری است'
                                                    }
                                                ]}
                                                style={{ width: '100%' }}
                                            >
                                                <Radio.Group key={'EvaluationMethod'} onChange={e => this.setState({ evaluationMethod: e.target.value })}>
                                                    {evaluationMethodsOptions.filter(s => s.disabled === false).map(s =>
                                                        <Col key={s.value} style={{ marginTop: 10, lineHeight: "normal" }}>
                                                            <Radio key={s.value} value={s.value}>{s.makingContactTitle}</Radio>
                                                        </Col>
                                                    )}

                                                    {/*{this.state.evaluationMethod === enmEvaluationMethods.PolicyholderInPerson && <Alert style={{ marginTop: 10 }} message="تاریخ و آدرس مراجعه به مرکز ارزیابی، متعاقبا از طریق پیام کوتاه به اطلاعتان خواهد رسید" type="info" showIcon />}*/}
                                                    {/*{this.state.evaluationMethod === enmEvaluationMethods.VideoCall && <Alert style={{ marginTop: 10 }} message="تاریخ و زمان و نحوه ارزیابی تماس تصویری، متعاقبا از طریق پیام کوتاه به اطلاعتان خواهد رسید" type="info" showIcon />}*/}
                                                    {/*{this.state.evaluationMethod === enmEvaluationMethods.EvaluatorInPerson && <Alert style={{ marginTop: 10 }} message="تاریخ و زمان مراجعه ارزیاب به آدرس محل حضور دستگاه آسیب دیده، متعاقبا از طریق پیام کوتاه به اطلاعتان خواهد رسید" type="info" showIcon />}*/}
                                                    {/*{this.state.evaluationMethod === enmEvaluationMethods.VideoCall ? <Alert style={{ marginRight: 10 }} message="لطفا مطمئن شوید که امکان برقراری تماس تصویری دارید" type="warning" showIcon /> : <></>}*/}

                                                </Radio.Group>
                                            </Form.Item>

                                        </Descriptions.Item>

                                        <Descriptions.Item key="selectedEvaluator" className={span === 1 ? "ant-col-24" : "ant-col-12"}>
                                            <Form.Item
                                                name="selectedEvaluator"
                                                key="selectedEvaluator"
                                                label="ارزیاب"
                                                labelCol={{ span: 8 }}
                                                wrapperCol={{ span: 16 }}
                                                style={{ width: '100%' }}
                                                extra={
                                                    this.state.selectedEvaluator &&
                                                    <Alert type="info" style={{ marginTop: 10 }} message={
                                                        <Space direction="vertical">
                                                            <Descriptions >
                                                                <Descriptions.Item label={"آدرس"}> {this.state.selectedEvaluator?.Address}</Descriptions.Item>
                                                            </Descriptions>
                                                            {this.state.selectedEvaluator.Phone &&
                                                                <Descriptions>
                                                                    <Descriptions.Item label={"تلفن"}>
                                                                        <b style={{ unicodeBidi: "plaintext" }}>{this.state.selectedEvaluator.Phone.startsWith('9') ? `0${this.state.selectedEvaluator.Phone}` : `0${this.state.selectedEvaluator.Phone}`.replace(/\D+/g, '').replace(/(\d{3})(\d+)/, '$1 - $2')}</b>
                                                                    </Descriptions.Item>
                                                                </Descriptions>
                                                            }
                                                            {this.state.selectedEvaluator.WorkTime &&
                                                                <Descriptions key="workTime">
                                                                    <Descriptions.Item label={"ساعت کار"} > {this.state.selectedEvaluator.WorkTime}</Descriptions.Item>
                                                                </Descriptions>
                                                            }
                                                            {!!this.state.selectedEvaluator.Longitude && !!this.state.selectedEvaluator.Latitude &&
                                                                <Descriptions key="map">
                                                                    <Descriptions.Item>
                                                                        <SimpleMap
                                                                            disableChangeMarker={true}
                                                                            cityName={this.state.selectedEvaluator.CityName}
                                                                            lat={this.state.selectedEvaluator.Latitude}
                                                                            lng={this.state.selectedEvaluator.Longitude}
                                                                        />
                                                                    </Descriptions.Item>
                                                                </Descriptions>
                                                            }
                                                        </Space>
                                                    } />
                                                }
                                            >
                                                <Lookup
                                                    preLoad={true}
                                                    parent={this}
                                                    onChange={(evaluator?: ICenter) => {
                                                        this.setState({ selectedEvaluator: evaluator });
                                                    }}
                                                    disabled={disableEvaluator}
                                                    property={this.evaluatorProp}
                                                    onDataFetched={result => {
                                                        this._form?.resetFields(["EvaluationMethod"]);
                                                        this.setState({ evaluatorsCount: (result as IEvaluatorFetchingResultDto).EvaluatorsCount, evaluationMethod: undefined });
                                                    }}
                                                    preparelookupProps={(lookupProps: IEvaluatorProps) => {
                                                        lookupProps.provinceCode = this.state.province?.Code;
                                                        lookupProps.cityCode = this.state.city?.Code;
                                                        return lookupProps;
                                                    }}
                                                />
                                            </Form.Item>
                                        </Descriptions.Item>
                                    </Descriptions>
                                </div>
                            </div>
                        </div>
                    }

                    {!!messageNode &&
                        <div key={"ContactSettingMessage"} className="box" style={{ marginBottom: 10 }}>
                            <div style={{ direction: "rtl" }}>
                                <Alert type="info" style={{ marginTop: 10 }} message={messageNode} />
                            </div>
                        </div>
                    }

                    <Form.Item wrapperCol={{ dir: 'ltr' }} style={{ zIndex: 1000, borderTop: '1px solid', borderColor: '#e5e5e5', marginTop: 10, padding: '10px 45px' }}>
                        <Button type="primary" htmlType="submit" icon={<ArrowLeftOutlined />} loading={this.state.loading} style={{ width: "100px", marginTop: 10, marginBottom: 10 }}>
                            ادامه
                        </Button>
                        <Button type="ghost" htmlType="reset" icon={<StopOutlined />} loading={this.state.loading} style={{ width: "100px", marginTop: 10, marginBottom: 10, marginLeft: 10, background: '#fff' }}>
                            لغو
                        </Button>
                    </Form.Item>
                </Form>
            </div>
        );
    }
}